import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { Button, Modal } from "@covertree/ui";

interface SurplusLinesInformationModalProps {
  open: boolean;
  onClose: () => void;
}

export function SurplusLinesInformationModal({
  open,
  onClose,
}: SurplusLinesInformationModalProps) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      maxWidth="sm"
      title="Surplus Lines Notice"
      modalSx={{ zIndex: 1500 }}
      sx={{
        paddingLeft: { xs: 2, sm: 0 },
        paddingRight: { xs: 2, sm: 0 },
      }}>
      <Box sx={{ py: 2, display: "flex", flexDirection: "column", gap: 2 }}>
        <Typography sx={{ textAlign: "left" }}>
          Coverage in North Carolina is written by Evanston Insurance Company, a
          member of the Markel family of companies. Evanston is rated A
          (Excellent) by AM Best and is one of the largest and most established
          specialty insurers in the country.
        </Typography>
        <Typography sx={{ textAlign: "left" }}>
          Because Evanston writes on a surplus lines basis, North Carolina
          requires us to share the following notice:
        </Typography>
        <Typography sx={{ textAlign: "left" }}>
          &quot;The insurance company with which this coverage has been placed
          is not licensed by the State of North Carolina and is not subject to
          its supervision. In the event of the insolvency of the insurance
          company, losses under this policy will not be paid by any State
          insurance guaranty or solvency fund.&quot;
        </Typography>
        <Box mt={3}>
          <Button onClick={onClose}>I Understand, Continue</Button>
        </Box>
      </Box>
    </Modal>
  );
}
